import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthProvider";

const PrivateRoute = () => {
  const {token, setToken} = useAuth();
  if(setToken) return null;
  if (!token) return <Navigate to="/login" replace/>;
  return <Outlet />;
};

export default PrivateRoute;
